var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPreview)?_c('div',{staticClass:"alert alert-warning d-flex justify-content-between align-items-center",staticStyle:{"margin-bottom":"0"}},[_c('span',{staticClass:"flex-grow-1"},[_vm._v("Preview mode")]),_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":_vm.exitPreview}},[_vm._v("Go to live mode")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }